function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#b8c8cc",
  d: "M9.193 24.141a1.2 1.2 0 0 1-1.2-1.2v-15.479a1.2 1.2 0 0 1 1.826-1.018l12.122 7.493a1.2 1.2 0 0 1 .029 2.017l-12.121 7.986a1.181 1.181 0 0 1-.656.201zm.429-15.907v13.915l10.9-7.179z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#b8c8cc",
  d: "M20.835 7.504h1.676v15.404H20.835z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#b8c8cc",
  d: "M9.193 24.141a1.2 1.2 0 0 1-1.2-1.2v-15.479a1.2 1.2 0 0 1 1.826-1.018l12.122 7.493a1.2 1.2 0 0 1 .029 2.017l-12.121 7.986a1.181 1.181 0 0 1-.656.201zm.429-15.907v13.915l10.9-7.179z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#b8c8cc",
  d: "M20.835 7.504h1.676v15.404H20.835z"
});

var SvgPrev = function SvgPrev(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "scale(-1,1) translate(-30,0)"
  }, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    style: {
      opacity: 0.2
    }
  }, _ref4, _ref5)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrev, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prev.96d94807.svg";
export { ForwardRef as ReactComponent };